import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ElfNgRouterStoreModule } from '@ngneat/elf-ng-router-store';

import { RsFooterShellRoutingModule } from './rs-footer-shell-routing.module';
import { ShellComponent } from './shell/shell.component';

@NgModule({
  imports: [CommonModule, ElfNgRouterStoreModule, RsFooterShellRoutingModule],
  declarations: [ShellComponent],
})
export class RsFooterShellModule {}
